"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const credentials = [{
  name: "PMP",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1595871/img/credential_pmp_logo.png"
}, {
  name: "ACP",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1595871/img/credential_acp_logo.png"
}, {
  name: "CPAM",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1595871/img/credential_cpam_logo.png"
}, {
  name: "PRINCE2",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1595871/img/credential_prince2_logo.png"
}, {
  name: "Certified ServiceNow Administrator",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1595871/img/credential_servicenow_logo.png"
}];
export default function EliteCredentials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}